import moment from 'moment'
import dateFormats from '../../configuration/dateFormats'
import cleanObject from '../../utilities/data/cleanObject'
import { createSelector } from 'reselect'

import { selectQueryParamsRelatedState } from './selectQueryParamsRelatedState'

export const selectQueryParams = createSelector(
  selectQueryParamsRelatedState,
  ({
    departureDate,
    departureRoute,
    returnDate,
    returnRoute,
    activeRouteForm,
    departureAdults,
    departureSeniors,
    departureStudents,
    departureChildren,
    departureInfants,
    departurePets,
    returnAdults,
    returnSeniors,
    returnStudents,
    returnChildren,
    returnInfants,
    returnPets,
    duplicatePassengerQuantities,
    language
  }) => {
    const result = new URLSearchParams()
    let params = {
      departureDate: departureDate
        ? moment(departureDate).format(dateFormats.default)
        : '',
      returnDate:
        activeRouteForm !== 'OW' && returnDate
          ? moment(returnDate).format(dateFormats.default)
          : '',
      tripType: activeRouteForm,
      departureRoute: departureRoute ? departureRoute.code : '',
      returnRoute:
        activeRouteForm !== 'OW' && returnRoute ? returnRoute.code : '',
      adults: departureAdults,
      seniors: departureSeniors,
      children: departureChildren,
      infants: departureInfants,
      students: departureStudents,
      pets: departurePets,
      language
      // vehicleType: selectVehicleFormType(state)
    }

    if (!duplicatePassengerQuantities) {
      params = {
        ...params,
        returnAdults,
        returnSeniors,
        returnStudents,
        returnChildren,
        returnInfants,
        returnPets
      }
    }

    const cleanParams = cleanObject(params)

    for (const [key, val] of Object.entries(cleanParams)) {
      result.append(key, val)
    }

    return result.toString()
  }
)
